type OptionsError = Partial<{
    message: string
    cause: string
    stack: string
}>

export class SyncSaleError extends Error {

    constructor(options?: OptionsError) {
        super();
        this.name = "Sync::sale"
        this.message = options?.message || 'Error synchronizing sale'
        this.cause = options?.cause
        this.stack = options?.stack
        Object.setPrototypeOf(this, SyncSaleError.prototype);
    }

}